import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { ContainerLoad } from 'src/app/domain/models/Pallet';

import { TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { FilterService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { ProfileContactInfo } from 'src/app/domain/models/Profile';
import { Routes } from 'src/app/infrastructure/routes';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { FilterLoadsUtils, MyLoadsFilter } from 'src/app/ui/util/custom-filters-my-loads';


@Component({
  selector: 'app-user-load-containers-orders',
  templateUrl: './user-load-containers-orders.component.html',
  styleUrls: ['./user-load-containers-orders.component.css'],

})
export class UserLoadContainersOrdersComponent {

  profile: ProfileContactInfo | undefined
  companyName: string = ""
  orders: LoadOrderListItem[] = []
  shipments: LoadOrderListItem[] = []
  searchTerm: string = '';

  containerLoads: ContainerLoad[] = []

  loading: boolean = false
  year: number = new Date().getFullYear()

  filteredRegisters: ContainerLoad[] = []
  containerFilter: SelectItem[] = []
  weekFilter: SelectItem[] = []
  importerFilter: SelectItem[] = []
  specieFilter: SelectItem[] = []
  varietyFilter: SelectItem[] = []
  shipFilter: SelectItem[] = []

  filter: MyLoadsFilter | undefined;
  selectedCompanies!: string[];
  selectedContainers!: string[];
  lang: string = 'en';
  yearSelect: number[] = []

  years: number[] = []

  profileUser: BasicUser | undefined

  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  constructor(
    private _router: Router,
    private _messageService: MessageService,
    private _palletService: PalletGateway,
    public translateService: TranslateService,
    private _authService: AuthGateway,
    private _profileService: ProfileService

  ) {
    if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
      this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
    }
  }

  ngOnInit(): void {

    this.profileUser = this._authService.getUser()

    let breadcrumbMenuItemLabel1 = 'Container view'
    let breadcrumbHomeMenuItemLabel = 'My loads'

    if(this.profileUser) {
      switch(this.profileUser.lang) {
        case 'en':
          breadcrumbMenuItemLabel1 = 'Container view'
          breadcrumbHomeMenuItemLabel = 'My loads'
          break
        case 'es':
          breadcrumbMenuItemLabel1 = 'Vista Contenedores'
          breadcrumbHomeMenuItemLabel = 'Mis cargas'
          break
      }
    }

    this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
    this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrders };


    this.getYears()

    this.loadContainer()
    this.companyName = this._authService.getUser()?.companyName ?? ""
    this._profileService.getContactInfo().subscribe({
      next: (v) => {
        this.profile =  v
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translateService.instant('MessageService.Summary.FailedAction'),
          detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
      },
    })
  }

  getYears() {
    let current = new Date()
    let currentYear = current.getFullYear()

    for(let i = 2023; i <= currentYear; i++) {
      this.years.push(i)
    }
  }

  filterLoads() {
    if (!this.searchTerm.trim()) {
      // Si el término de búsqueda está vacío, mostrar todos los pedidos
      this.filteredRegisters = this.containerLoads;
    } else {
      // Filtrar los pedidos basados en el término de búsqueda
      this.filteredRegisters = this.containerLoads.filter(product =>
        product.importer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.week?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.etd?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.eta?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.containerNumber?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.ship?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.departurePort?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        product.destinationPort?.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    }
  }

  exportExcel(table: Table) {
    const tableExport = table.filteredValue ? table.filteredValue : this.filteredRegisters;

    import('xlsx').then((xlsx) => {
      let sheets: any[] = []
      if(tableExport) {
        tableExport.forEach(x => {
          let row = {
            [this.translateTextExcel('ImportOrderIdHeader')]: x.importOrderId,
            [this.translateTextExcel('ImporterHeader')]: x.importer,
            [this.translateTextExcel('WeeksHeader')]: x.week,
            [this.translateTextExcel('ETAHeader')]: x.etd,
            [this.translateTextExcel('ETDHeader')]: x.eta,
            [this.translateTextExcel('ContainerHeader')]: x.containerNumber,
            [this.translateTextExcel('EspecieHeader')]: x.species,
            [this.translateTextExcel('VarietyHeader')]: x.variety,
            [this.translateTextExcel('PackagingHeader')]: x.packaging,
            [this.translateTextExcel('NetKilosHeader')]: x.netKilos,
            [this.translateTextExcel('LabelHeader')]: x.boxType,
            [this.translateTextExcel('SpeciesSize')]: x.speciesSize,
            [this.translateTextExcel('BoxesPerPalletHeader')]: x.boxesPerPallet,
            [this.translateTextExcel('VesselNameHeader')]: x.ship,
            [this.translateTextExcel('OriginPortHeader')]: x.departurePort,
            [this.translateTextExcel('DestinationPortHeader')]: x.destinationPort,
            [this.translateTextExcel('PricePerBox')]: x.importOrderDetail?.price,
            [this.translateTextExcel('Incoterms')]: x.incoterms,
          }
          sheets.push(row)
        })
      }
      const worksheet = xlsx.utils.json_to_sheet(sheets);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      let reportName = this.lang === 'es' ? 'Reporte Contenedor' : 'Report Container';
      this.saveAsExcelFile(excelBuffer, reportName);
    });
  }

  @ViewChild('loadContainersTable') dt: any;
  ngAfterContentInit(): void{
  }

  filterTable(event: any) {
    let filterData  = event.filteredValue;
    this.buildFilters(filterData)
  }

  // Funcion para setear variables filtro
  configFilter()
  {

    this.filter = FilterLoadsUtils.getFilterConfig()

    if(this.filter)
    {
      if(this.filter.profileName)
      {
        this.selectedCompanies = [];
        this.selectedCompanies.push(this.filter.profileName)
        this.dt.filters['importer'] = [
          {value: this.selectedCompanies, matchMode: "in"}
        ]
      }

      if(this.filter.container)
      {
        this.selectedContainers = [];
        this.selectedContainers.push(this.filter.container)
        this.dt.filters['containerNumber'] = [{value: this.selectedContainers, matchMode: "in"}]
      }

      if(this.filter.year)
      {
        this.year = this.filter.year;
      }

    }

    this.updateSelectedYear()
  }

  translateTextExcel(text: string) {
    return this.translateService.instant(`UserPages.UserLoadContainersOrders.MainTable.${text}`);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    let date = new Date()
    var FileSaver = require('file-saver');
    FileSaver.saveAs(data, fileName + '-' + date.getDate()  + '-' + (date.getMonth() + 1) + '-' +date.getFullYear() + EXCEL_EXTENSION);
  }



  loadContainer(){
    this.loading = true;
    let config = FilterLoadsUtils.getFilterProgramConfig()

    if(config){
      if(config.year){
        this.year = config.year
      }
    }

    this._palletService.getUserContainerLoad(this.year, false).subscribe({
      next: (v) => {
        this.loading = false;
        this.containerLoads = v
        this.filteredRegisters = v
        this.buildFilters(this.filteredRegisters);
        this.configFilter()
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los Master Loads.' });
      },
    })
  }

  buildFilters(containerLoad: ContainerLoad[])
  {
    this.containerFilter = []
    this.weekFilter = []
    this.specieFilter = []
    this.varietyFilter = []
    this.importerFilter = []


    containerLoad.forEach((item) => {
      if (item.containerNumber && !this.containerFilter.some((x) => item.containerNumber === x.label)) {
        this.containerFilter.push({label:item.containerNumber, value: item.containerNumber})
      }
      if (item.week && !this.weekFilter.some((x) => x.value === item.week)) {
        this.weekFilter.push({label: item.week.toString(), value: item.week })
      }
      if (item.importer && !this.importerFilter.some((x) => x.label === item.importer)) {
        this.importerFilter.push({label: item.importer, value: item.importer})
      }
      if (item.ship && !this.shipFilter.some((x) => x.label === item.ship)) {
        this.shipFilter.push({label: item.ship, value: item.ship} )
      }
    })

    this.weekFilter.sort((x) => x.value)
    this.containerFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.specieFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.shipFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.varietyFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.importerFilter.sort((a, b) => a.value.localeCompare(b.value))
  }

  getTransportName(transportType: number)
  {
    return TransportTypeUtils.getTransportName(this.translateService.currentLang, transportType);
  }

  goToLoadsPage(): void {
    this.clearFilters()
    this._router.navigate([Routes.userLoadOrders]);
  }

  clearFilters() {
    sessionStorage.removeItem("dt-masterload-session")
  }

  updateSelectedYear()
  {
    this.yearSelect = []
    this.yearSelect.push(this.year);
  }

  removeConfigFilter()
  {
    FilterLoadsUtils.removeFilterConfig()
  }

  searchLoadContainers(event: any)
  {
    this.removeConfigFilter()
    if(event.value.length > 0)
    {
      this.year = event.value[0]
      this.loadContainer()
    }else{
      this.containerLoads = []
      this.filteredRegisters = []
      this.yearSelect = []
    }
  }

}
